import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { autobind } from 'core-decorators'

import Error from '../components/Error'

@observer
export default class ErrorContainer extends Component {
  static propTypes = {
    causingComponent: PropTypes.shape({
      error: PropTypes.object,
      resolveError: PropTypes.func
    }),
    children: PropTypes.node,
    className: PropTypes.string,
  }

  @autobind
  handleClose() {
    this.props.causingComponent.resolveError()
  }

  render() {
    const { causingComponent, className, children } = this.props
    let content = children
    let error = null

    if (causingComponent && causingComponent.error) {
      error = causingComponent.error

      const stack = error.stack || error.trace

      content = (
        <div>
          <div className="v-scrollable">
            <h3>
              Es ist ein Fehler aufgetreten:
              {error.message}
            </h3>
            <div className="v-scrollable">
              {stack ? <pre>{stack}</pre> : null}
            </div>
            <hr />
            <div>
              Bitte wiederholen sie die Aktion.
              {' '}
              <br />
              <br />
              Sollte der Fehler weiterhin auftreten, machen Sie bitte programformcontainer
              Screenshot von diesem Fenster und senden ihn an den Administrator.
            </div>
          </div>
          <div className="button-row">
            <button
              className="btn btn-default pull-right"
              onClick={this.handleClose}
            >
              Schließen
            </button>
          </div>
        </div>
      )
    }

    if (!content) {
      return null
    }

    return (
      <Error className={className}>
        {content}
      </Error>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/containers/Error.js